import * as React from "react";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../app/hooks";
import { WheelchairActivityType } from "../data/interfaces/types";
import bestAvailableModelSlice from "../data/slices/best-available-model-slice";

interface WheelchairActivityTypeProps {
    activityType: WheelchairActivityType;
    index: number;
}

export const ActivityType: React.FC<WheelchairActivityTypeProps> = ({ activityType, index }) => {
    const wheelchairActivityTypes = useAppSelector((state) => state.bestAvailableModel.priceTypeQuantities);
    const [currentActivityTypes, setCurrentActivityTypes] = useState(wheelchairActivityTypes);
    const [currentIsSelectedValue, setCurrentIsSelectedValue] = useState(activityType.isSelected);
    const dispatch = useDispatch();

    useEffect(() => { setCurrentActivityTypes(wheelchairActivityTypes) }, [wheelchairActivityTypes])
    useEffect(() => { setCurrentIsSelectedValue(activityType.isSelected) }, [activityType.isSelected])

    const updateActivityType = (isSelected: boolean) => {
        let newActivityType: WheelchairActivityType = {
            activityTypeId: activityType.activityTypeId,
            activityTypeDescription: activityType.activityTypeDescription,
            isSelected: isSelected
        }

        dispatch(bestAvailableModelSlice.actions.updateActivityTypes(newActivityType));
    }

    return (
        <li key={index}>
            <input onChange={(e) => {
                updateActivityType(e.target.checked)
            }} type="radio" defaultChecked={false} id={activityType.activityTypeId.toString()} name="activityType" value={currentIsSelectedValue.toString()} />
            <label htmlFor={activityType.activityTypeId.toString()} >
                {activityType.activityTypeDescription}
            </label>
        </li>
    )
}